import { render, staticRenderFns } from "./subStoreGoods.vue?vue&type=template&id=31cea79a&"
import script from "./subStoreGoods.vue?vue&type=script&lang=js&"
export * from "./subStoreGoods.vue?vue&type=script&lang=js&"
import style0 from "./subStoreGoods.vue?vue&type=style&index=0&id=31cea79a&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports